<template>
  <div class="home">
    <header class="home__header">
      <img alt="Sommer Madness" src="../assets/logo.svg" class="home__logo">
      <p class="home__lead">Królowa Przedmieścia oraz RADOŚĆ zapraszają:</p>
      <h1>Mateusz Ulman Takeover <br><small>(Lille Format / Kopenhaga)</small></h1>
    </header>
    <section>
      <p class="date"><span>19.08.23</span></p>

      <h3>Śniadanie / Brunch</h3>
      <p class="hour">10:00 – 15:00</p>
      <hr/>

      <h3>Kolacja</h3>
      <p class="hour">19:00 – 23:00</p>
      <p class="copy">
        Wyjątkowa kolacja w stylu Long Table,<br> z daniami serwowanymi przez Mateusza Ulmana. <br>
        Liczba miejsc ograniczona, obowiązuje wcześniejsza rezerwacja.
      </p>
      <router-link class="button buton--blue" to="/menu">Zobacz menu</router-link>
      <hr/>

      <p class="date"><span>20.08.23</span></p>

      <h3>Śniadanie / Brunch</h3>
      <p class="hour">10:00 - 15:00</p>
      <hr/>
      <h3>Zapraszamy!</h3>
      <img class="home__chair" alt="Królowa X Radość" src="../assets/krzeselko.png" width="58">
    </section>

  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'HomeView',
};
</script>

<style lang="scss">
@import '../assets/mixins.scss';

.home {
  padding: 67px 0;
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  text-align: center;
  color: #352d89;

  @include text-paragraph;

  &__logo {
    width: 100%;
    max-width: 350px;
    margin: 0 auto;
    display: block;
    margin: 0 auto 34px;
  }

  &__header {
    margin: 0 0 20px;
  }

  &__lead {
    @include text-paragraph;
    margin: 0 0 12px;
  }

  &__chair {
    display: block;
    margin: 20px auto 0;
  }
}

.hour {
  @include text-paragraph;
  margin: 0 0 14px;
}

.copy {
  font-size: 14px;
  letter-spacing: -0.055px;
  margin: 0 0 30px;
}

.date {
  position: relative;

  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    height: 1px;
    top: 50%;
    background: #352d89;
    z-index: 0;
  }

  span {
    font-family: 'SangBleuKingdom', Arial, sans-serif;
    letter-spacing: -2.9px;
    position: relative;
    display: inline-block;
    background: #fff;
    padding: 0 1.5em;
  }
}
</style>
